import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";

/**
 * DeleteProgressModal - Modal component yang modern dan elegan untuk proses penghapusan
 */
export default class DeleteProgressModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getStepStyles(status) {
        switch (status) {
            case "pending":
                return {
                    container: "bg-gray-50 border border-gray-200",
                    icon: "bg-gray-200 text-gray-400",
                    iconClass: "bx-circle",
                    text: "text-gray-500",
                    badge: null,
                };
            case "running":
                return {
                    container: "bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 shadow-sm",
                    icon: "bg-gradient-to-br from-blue-500 to-indigo-600 text-white animate-pulse",
                    iconClass: "bx-loader-alt bx-spin",
                    text: "text-blue-700 font-medium",
                    badge: "bg-blue-100 text-blue-600",
                };
            case "success":
                return {
                    container: "bg-gradient-to-r from-emerald-50 to-green-50 border border-emerald-200",
                    icon: "bg-gradient-to-br from-emerald-500 to-green-600 text-white",
                    iconClass: "bx-check",
                    text: "text-emerald-700",
                    badge: "bg-emerald-100 text-emerald-600",
                };
            case "error":
                return {
                    container: "bg-gradient-to-r from-red-50 to-rose-50 border border-red-200",
                    icon: "bg-gradient-to-br from-red-500 to-rose-600 text-white",
                    iconClass: "bx-x",
                    text: "text-red-700 font-medium",
                    badge: "bg-red-100 text-red-600",
                };
            default:
                return {
                    container: "bg-gray-50 border border-gray-200",
                    icon: "bg-gray-200 text-gray-400",
                    iconClass: "bx-circle",
                    text: "text-gray-500",
                    badge: null,
                };
        }
    }

    render() {
        const {
            show,
            onHide,
            steps = [],
            error,
            onConfirm,
            onRetry,
            isDeleting,
            isComplete,
            userName,
            userType = "Siswa", // Default to Siswa for backward compatibility
            deleteItems = null, // Custom delete items list
        } = this.props;

        // Default items for each user type
        const defaultDeleteItems = {
            Siswa: [
                { icon: "bx-book-open", text: "Relasi mata pelajaran siswa" },
                { icon: "bx-group", text: "Relasi rombel dan kelas" },
                { icon: "bx-user-circle", text: "Data orang tua terkait" },
                { icon: "bx-key", text: "Akun SSO (login) siswa" },
                { icon: "bx-user-x", text: "Data profil user siswa" },
            ],
            Guru: [
                { icon: "bx-chalkboard", text: "Status wali kelas guru" },
                { icon: "bx-time", text: "Jadwal waktu mengajar" },
                { icon: "bx-book-open", text: "Penugasan mata pelajaran" },
                { icon: "bx-briefcase", text: "Penugasan guru" },
                { icon: "bx-key", text: "Akun SSO (login) guru" },
                { icon: "bx-user-x", text: "Data profil user guru" },
            ],
            Lainnya: [
                { icon: "bx-key", text: "Akun SSO (login) staff" },
                { icon: "bx-briefcase", text: "Penugasan lainnya" },
                { icon: "bx-user-x", text: "Data profil user staff" },
            ],
        };

        const itemsToShow = deleteItems || defaultDeleteItems[userType] || defaultDeleteItems.Siswa;

        const modalStyles = {
            content: {
                borderRadius: '16px',
                border: 'none',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            }
        };

        return (
            <Modal
                show={show}
                onHide={onHide}
                backdrop={isDeleting ? "static" : true}
                keyboard={!isDeleting}
                centered
                dialogClassName="delete-progress-modal"
            >
                <style>
                    {`
            .delete-progress-modal .modal-content {
              border-radius: 20px;
              border: none;
              overflow: hidden;
              box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            }
            @keyframes slideIn {
              from { opacity: 0; transform: translateY(10px); }
              to { opacity: 1; transform: translateY(0); }
            }
            @keyframes pulse-ring {
              0% { transform: scale(0.95); opacity: 0.5; }
              50% { transform: scale(1.05); opacity: 0.3; }
              100% { transform: scale(0.95); opacity: 0.5; }
            }
            .step-enter {
              animation: slideIn 0.3s ease-out forwards;
            }
            .pulse-bg::before {
              content: '';
              position: absolute;
              inset: -4px;
              background: linear-gradient(135deg, #3b82f6, #6366f1);
              border-radius: 50%;
              animation: pulse-ring 2s infinite;
              z-index: -1;
            }
            .success-checkmark {
              animation: slideIn 0.5s ease-out forwards;
            }
          `}
                </style>

                {/* Header */}
                <div className={`px-6 pt-6 pb-4 ${isComplete
                    ? 'bg-emerald-600 bg-gradient-to-r from-emerald-500 to-green-600'
                    : error
                        ? 'bg-red-600 bg-gradient-to-r from-red-500 to-rose-600'
                        : 'bg-red-700 bg-gradient-to-r from-red-700 to-red-600'
                    }`}>
                    <div className="flex items-center">
                        <div className={`w-12 h-12 rounded-full flex items-center justify-center mr-4 ${isComplete
                            ? 'bg-white bg-opacity-20'
                            : error
                                ? 'bg-white bg-opacity-20'
                                : 'bg-white bg-opacity-10'
                            }`}>
                            {isComplete ? (
                                <i className="bx bx-check text-white text-3xl success-checkmark"></i>
                            ) : error ? (
                                <i className="bx bx-error-circle text-white text-3xl"></i>
                            ) : (
                                <i className="bx bx-trash text-white text-3xl"></i>
                            )}
                        </div>
                        <div>
                            <h5 className="text-lg font-bold text-white m-0">
                                {isComplete
                                    ? "Penghapusan Berhasil"
                                    : error
                                        ? "Penghapusan Gagal"
                                        : `Hapus User ${userType}`}
                            </h5>
                            {userName && (
                                <p className="text-sm text-white m-0 mt-1">{userName}</p>
                            )}
                        </div>
                    </div>
                </div>

                <Modal.Body className="p-6">
                    {/* Confirmation view - before delete starts */}
                    {!isDeleting && !isComplete && !error && (
                        <div className="step-enter">
                            <div className="bg-red-50 bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-6 mb-5 border border-red-200">
                                <div className="flex items-start">
                                    <div className="w-14 h-14 rounded-full bg-red-500 bg-gradient-to-br from-red-500 to-orange-500 flex items-center justify-center mr-4 flex-shrink-0">
                                        <i className="bx bx-error text-white text-3xl"></i>
                                    </div>
                                    <div>
                                        <h6 className="text-lg font-bold text-gray-800 mb-1">Konfirmasi Penghapusan</h6>
                                        <p className="text-gray-600 text-sm mb-0">
                                            Tindakan ini tidak dapat dibatalkan. Semua data terkait {userType.toLowerCase()} ini akan dihapus secara permanen.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-gray-50 rounded-xl p-5 border border-gray-100">
                                <p className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                                    <i className="bx bx-list-check text-gray-400 text-lg mr-2"></i>
                                    Data yang akan dihapus:
                                </p>
                                <div className="space-y-2">
                                    {itemsToShow.map((item, idx) => (
                                        <div key={idx} className="flex items-center text-sm text-gray-600 pl-1">
                                            <i className={`bx ${item.icon} text-gray-400 mr-3`}></i>
                                            <span>{item.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Progress view - during delete */}
                    {(isDeleting || isComplete || error) && (
                        <div className="space-y-3">
                            {steps.map((step, index) => {
                                const styles = this.getStepStyles(step.status);
                                return (
                                    <div
                                        key={index}
                                        className={`flex items-center p-4 rounded-xl transition-all duration-300 step-enter ${styles.container}`}
                                        style={{ animationDelay: `${index * 100}ms` }}
                                    >
                                        <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0 relative ${styles.icon}`}>
                                            <i className={`bx ${styles.iconClass} text-lg`}></i>
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <span className={`text-sm ${styles.text}`}>
                                                {step.name}
                                            </span>
                                        </div>
                                        {step.status === "running" && (
                                            <span className="text-xs px-3 py-1 rounded-full bg-blue-100 text-blue-600 font-medium ml-2">
                                                Proses...
                                            </span>
                                        )}
                                        {step.status === "success" && (
                                            <span className="text-xs px-3 py-1 rounded-full bg-emerald-100 text-emerald-600 font-medium ml-2">
                                                Selesai
                                            </span>
                                        )}
                                        {step.status === "error" && (
                                            <span className="text-xs px-3 py-1 rounded-full bg-red-100 text-red-600 font-medium ml-2">
                                                Gagal
                                            </span>
                                        )}
                                    </div>
                                );
                            })}

                            {/* Error message */}
                            {error && (
                                <div className="bg-gradient-to-r from-red-50 to-rose-50 border border-red-200 rounded-xl p-4 mt-4 step-enter">
                                    <div className="flex items-start">
                                        <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center mr-3 flex-shrink-0">
                                            <i className="bx bx-error-circle text-red-500 text-xl"></i>
                                        </div>
                                        <div>
                                            <p className="text-sm font-semibold text-red-700 mb-1">
                                                Terjadi Kesalahan
                                            </p>
                                            <p className="text-sm text-red-600 mb-0">{error}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Success message */}
                            {isComplete && (
                                <div className="bg-gradient-to-r from-emerald-50 to-green-50 border border-emerald-200 rounded-xl p-4 mt-4 step-enter">
                                    <div className="flex items-center">
                                        <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mr-3 flex-shrink-0">
                                            <i className="bx bx-check-circle text-emerald-500 text-xl"></i>
                                        </div>
                                        <div>
                                            <p className="text-sm font-semibold text-emerald-700 mb-0">
                                                Semua data user {userType.toLowerCase()} berhasil dihapus dari sistem.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="border-t-0 px-6 pb-6 pt-2">
                    {/* Before delete - show confirm/cancel buttons */}
                    {!isDeleting && !isComplete && !error && (
                        <div className="flex w-full gap-3">
                            <button
                                className="flex-1 px-5 py-3 rounded-xl text-sm font-semibold bg-gray-400 text-gray-700 hover:bg-gray-500 transition-all duration-200"
                                onClick={onHide}
                            >
                                Batal
                            </button>
                            <button
                                className="flex-1 px-5 py-3 rounded-xl text-sm font-semibold bg-red-600 bg-gradient-to-br from-red-500 to-rose-600 text-white hover:from-red-600 hover:to-rose-700 transition-all duration-200 shadow-lg shadow-red-500/25"
                                onClick={onConfirm}
                            >
                                <i className="bx bx-trash mr-2"></i>
                                Ya, Hapus Sekarang
                            </button>
                        </div>
                    )}

                    {/* During delete - show processing state */}
                    {isDeleting && (
                        <button
                            className="w-full px-5 py-3 rounded-xl text-sm font-semibold bg-gray-200 text-gray-500 cursor-not-allowed"
                            disabled
                        >
                            <div className="flex items-center justify-center">
                                <div className="w-5 h-5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mr-3"></div>
                                Sedang Memproses...
                            </div>
                        </button>
                    )}

                    {/* After error - show retry/close buttons */}
                    {error && !isDeleting && (
                        <div className="flex w-full gap-3">
                            <button
                                className="flex-1 px-5 py-3 rounded-xl text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200 transition-all duration-200"
                                onClick={onHide}
                            >
                                Tutup
                            </button>
                            <button
                                className="flex-1 px-5 py-3 rounded-xl text-sm font-semibold bg-amber-500 bg-gradient-to-r from-amber-500 to-orange-600 text-white hover:from-amber-600 hover:to-orange-700 transition-all duration-200 shadow-lg shadow-amber-500/25"
                                onClick={onRetry}
                            >
                                <i className="bx bx-refresh mr-2"></i>
                                Coba Lagi
                            </button>
                        </div>
                    )}

                    {/* After success - show close button */}
                    {isComplete && (
                        <button
                            className="w-full px-5 py-3 rounded-xl text-sm font-semibold bg-emerald-500 bg-gradient-to-r from-emerald-500 to-green-600 text-white hover:from-emerald-600 hover:to-green-700 transition-all duration-200 shadow-lg shadow-emerald-500/25"
                            onClick={onHide}
                        >
                            <i className="bx bx-check mr-2"></i>
                            Selesai
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
        );
    }
}
